'use client';

import type { FC } from 'react';

import { useAtom } from 'jotai';

import { useClickOutside } from '@core/Hooks/UseClickOutside';
import { useLockBodyScroll } from '@core/Utils/UseBodyLockOnScroll';
import { Typography } from '@gds/Typography/Typography';
import { sortDrawerOpenAtom } from '@plp/Atoms/SortDrawerOpenAtom';

import type { Option, SortDrawerOptions } from './Sort.entity';

import styles from './SortDrawer.module.css';

const SortDrawer: FC<SortDrawerOptions> = ({
  sortByText,
  options,
  selectOption,
  selectedValue,
}) => {
  const [sortDrawerIsOpen, toggleSortDrawer] = useAtom(sortDrawerOpenAtom);
  useLockBodyScroll(sortDrawerIsOpen);

  const ref = useClickOutside<HTMLUListElement>(() => toggleSortDrawer(false));
  const isOptionSelection = (option: Option) => {
    return option?.value === selectedValue?.value;
  };

  return (
    <div className={`${styles.mobileDrawer} ${sortDrawerIsOpen ? styles.isOpen : ''}`}>
      <div className={styles.drawerContent}>
        <Typography Component="p" className={styles.drawerTitle} variant="subheading2">
          {sortByText}
        </Typography>
        <ul className={`${styles.options}`} data-test-id="sort-drawer" ref={ref}>
          {options.map((option, index) => (
            <li
              className={`${styles.option} ${isOptionSelection(option) ? styles.selected : ''} `}
              key={`${option.value}+${index}`}
              onMouseDown={() => {
                selectOption(option);
                toggleSortDrawer(false);
              }}
            >
              <div className={styles.contentContainer}>
                <Typography Component="span" className={styles.optionContent} variant="subheading4">
                  {option.label}
                </Typography>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SortDrawer;
